import { defineStore } from 'pinia'
import type { LoginResponse } from '@/types/user'
import {
  getToken, setToken, getSessionId, setSessionId,
  getUserId, setUserId, getUserName, setUserName,
  getAvatar, setAvatar, clearAuth,
} from '@/utils/token'
import { safeLocalStorage } from '@/utils/ssr'

interface UserState {
  token: string
  userId: string
  userName: string
  userHeadPortrait: string
  sessionId: string
  lang: string
  phone: string
}

export const useUserStore = defineStore('user', {
  state: (): UserState => ({
    token: getToken(),
    userId: getUserId(),
    userName: getUserName(),
    userHeadPortrait: getAvatar(),
    sessionId: getSessionId(),
    lang: safeLocalStorage.getItem('gibbous-web-lang') || 'zh-Hans',
    phone: '',
  }),

  getters: {
    isLoggedIn: (state) => !!state.token,
  },

  actions: {
    setLoginData(data: LoginResponse) {
      this.token = data.token
      this.userId = data.userId
      this.userName = data.userName
      this.userHeadPortrait = data.userHeadPortrait || ''
      this.sessionId = data.sessionId || ''
      setToken(data.token)
      setSessionId(data.sessionId || '')
      setUserId(data.userId)
      setUserName(data.userName)
      setAvatar(data.userHeadPortrait || '')
    },

    setSessionId(id: string) {
      this.sessionId = id
      setSessionId(id)
    },

    logout() {
      this.token = ''
      this.userId = ''
      this.userName = ''
      this.userHeadPortrait = ''
      this.sessionId = ''
      this.phone = ''
      clearAuth()
    },
  },
})
